import { ConfirmationModal } from 'modules/ui';
import { DeskControllerBase } from '../DeskControllerBase';
export class CategoriesController extends DeskControllerBase {
    static $inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', 'RepliesService2', 'SegmentService', 'ModalService', '$translate', 'ngToast'];
    constructor(application, DeskConfigurationService, LoadingService, $scope, RepliesService2, SegmentService, ModalService, $translate, ngToast) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.$scope = $scope;
        this.RepliesService2 = RepliesService2;
        this.SegmentService = SegmentService;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.page = 1;
        this.itemsPerPage = 8;
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.listItemsPerPage = [8, 25, 50, 100, 250, 500];
        this.onChangePage = async (page) => {
            this.LoadingService.startLoading();
            this.page = page;
            await this.getCategories();
            this.LoadingService.stopLoading();
        };
        this.onChangeItemPerPage = async (itemsPerPage) => {
            this.itemsPerPage = itemsPerPage;
            await this.reloadData();
        };
        this.getCategories = async () => {
            const skip = (this.page - 1) * this.itemsPerPage;
            try {
                const { items, total } = await this.RepliesService2.getAllCategories(skip, this.itemsPerPage);
                this.categories = items;
                this.totalNumberItems = total ?? 0;
            }
            catch (e) {
                console.error(e);
            }
        };
        this.setTotalNumberPages = () => {
            this.totalNumberPages = this.totalNumberItems !== 0 ? Math.ceil(this.totalNumberItems / this.itemsPerPage) : 1;
        };
    }
    async $onInit() {
        this.LoadingService.startLoading();
        this.contenDeletedSuccessMsg = await this.$translate('utils.successMsg.33');
        await this.getCategories();
        this.setTotalNumberPages();
        this.SegmentService.createBotTrack('helpdesk-custom-replies-opened', this.application);
        this.LoadingService.stopLoading();
    }
    async confirmDelete(item) {
        const modalTitle = await this.$translate('customReplies.categories.deleteModal.title');
        const modalBody = await this.$translate('customReplies.categories.deleteModal.body');
        const yes = await this.$translate('utils.misc.yes');
        const no = await this.$translate('utils.misc.no');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            await this.RepliesService2.delete(item.id);
            this.categories = this.categories.filter(c => c.id !== item.id);
            this.ngToast.success(this.contenDeletedSuccessMsg);
            await this.reloadData();
        }
    }
    createNewCategoryTrack() {
        this.SegmentService.createBotTrack('helpdesk-custom-replies-category-created', this.application);
    }
    async reloadData() {
        this.LoadingService.startLoading();
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.page = 1;
        await this.getCategories();
        this.setTotalNumberPages();
        this.LoadingService.stopLoading();
    }
}
CategoriesController.$inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', 'RepliesService2', 'SegmentService', 'ModalService', '$translate', 'ngToast'];
